// extracted by mini-css-extract-plugin
export var header = "_e0-0";